module.exports = __webpack_public_path__ + "static/media/fa-brands-400.6814d0e8.woff2";